import { createSelector } from '@reduxjs/toolkit';
import orderBy from 'lodash/orderBy';
import { MENTEE_MODULE_STATUSES } from '../data/menteeModuleStatuses';
import { CORE_MENTEE_MODULE_STATUSES } from '../data/coreMenteModuleStatuses';

const baseSelector = (state) => state.updateMenteeModule;

export const menteeModulesSelector = (state) =>
  baseSelector(state).menteeModules;

export const viewMiscellaneousMenteeModulesStateSelector = (state) =>
  baseSelector(state).viewMiscellaneousMenteeModulesState;

export const deleteMenteeModuleModalStateSelector = (state) =>
  baseSelector(state).deleteMenteeModuleModalState;

export const selectedMenteeModuleSelector = (state) =>
  baseSelector(state).selectedMenteeModule;

export const updateMenteeModuleStatusModalStateSelector = (state) =>
  baseSelector(state).updateMenteeModuleStatusModalState;

export const updateMenteeModuleOrderModalStateSelector = (state) =>
  baseSelector(state).updateMenteeModuleOrderModalState;

export const orderedMenteeModulesSelector = createSelector(
  (state) => baseSelector(state).menteeModules,
  (menteeModules) => orderBy(menteeModules, ['order'], ['asc'])
);

export const AddMenteeModuleModalStateSelector = (state) =>
  baseSelector(state).addMenteeModuleModalState;

export const AddMenteeModuleSelector = (state) =>
  baseSelector(state).addMenteeModule;

export const orderedCoreMenteeModulesSelector = createSelector(
  (state) => baseSelector(state).menteeModules,
  (menteeModules) =>
    orderBy(menteeModules, ['order'], ['asc']).filter((menteeModules) =>
      CORE_MENTEE_MODULE_STATUSES.includes(menteeModules.status)
    )
);

export const orderedMiscellaneousMenteeModulesSelector = createSelector(
  (state) => baseSelector(state).menteeModules,
  (menteeModules) =>
    orderBy(menteeModules, ['order'], ['asc']).filter(
      (menteeModules) =>
        menteeModules.status === MENTEE_MODULE_STATUSES.deprecated
    )
);

export const menteeModuleErrorSelector = (state) =>
  baseSelector(state).menteeModuleError;

export const menteeModuleTypeSelector = (state) =>
  baseSelector(state).menteeModuleType;
